import { AdmissionCycle, IdNamePair } from '../types/admissions';

const idOf = (c: unknown) => String((c as any)?._id ?? c);

/** Every class in the cycle has stopped taking applications. Works whether
 *  the cycle's classes are loaded with names or only as ids (the list). */
export const everyClassStopped = (cycle: Pick<AdmissionCycle, 'allowedClassIds' | 'intake'>): boolean => {
  const classes = (cycle.allowedClassIds || []).map(idOf);
  const stopped = new Set((cycle.intake?.closedClassIds || []).map(idOf));
  return classes.length > 0 && classes.every(id => stopped.has(id));
};

/** The cycle's classes that are taking applications now — what a new
 *  application (walk-in, bulk upload) may choose. A stopped class (e.g.
 *  full) is left out; the server refuses it too. */
export const classesTakingApplications = (cycle: Pick<AdmissionCycle, 'allowedClassIds' | 'intake'>): IdNamePair[] => {
  const stopped = new Set(cycle.intake?.closedClassIds || []);
  return (cycle.allowedClassIds || [])
    .filter((c): c is IdNamePair => typeof c === 'object' && !!c?._id)
    .filter(c => !stopped.has(c._id));
};
